const ICONOS = {
  Menu: ['<path d="M4 12h16"/>', '<path d="M4 18h16"/>', '<path d="M4 6h16"/>'],
  X: ['<path d="M18 6 6 18"/>', '<path d="m6 6 12 12"/>'],
  Search: ['<circle cx="11" cy="11" r="8"/>', '<path d="m21 21-4.3-4.3"/>'],
  ShoppingCart: [
    '<circle cx="8" cy="21" r="1"/>',
    '<circle cx="19" cy="21" r="1"/>',
    '<path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
  ],
  ShoppingBag: [
    '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>',
    '<path d="M3 6h18"/>',
    '<path d="M16 10a4 4 0 0 1-8 0"/>',
  ],
  Heart: [
    '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/>',
  ],
  ChevronLeft: ['<path d="m15 18-6-6 6-6"/>'],
  ChevronRight: ['<path d="m9 18 6-6-6-6"/>'],
  ChevronDown: ['<path d="m6 9 6 6 6-6"/>'],
  Plus: ['<path d="M5 12h14"/>', '<path d="M12 5v14"/>'],
  Minus: ['<path d="M5 12h14"/>'],
  Trash2: [
    '<path d="M3 6h18"/>',
    '<path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>',
    '<path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>',
    '<line x1="10" x2="10" y1="11" y2="17"/>',
    '<line x1="14" x2="14" y1="11" y2="17"/>',
  ],
  User: ['<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>', '<circle cx="12" cy="7" r="4"/>'],
  Home: [
    '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>',
    '<polyline points="9 22 9 12 15 12 15 22"/>',
  ],
  Filter: ['<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>'],
  SlidersHorizontal: [
    '<line x1="21" x2="14" y1="4" y2="4"/>',
    '<line x1="10" x2="3" y1="4" y2="4"/>',
    '<line x1="21" x2="12" y1="12" y2="12"/>',
    '<line x1="8" x2="3" y1="12" y2="12"/>',
    '<line x1="21" x2="16" y1="20" y2="20"/>',
    '<line x1="12" x2="3" y1="20" y2="20"/>',
    '<line x1="14" x2="14" y1="2" y2="6"/>',
    '<line x1="8" x2="8" y1="10" y2="14"/>',
    '<line x1="16" x2="16" y1="18" y2="22"/>',
  ],
  Star: [
    '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  ],
  Phone: [
    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.57 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.09a2 2 0 0 1 2.11-.45c.84.25 1.71.45 2.61.57A2 2 0 0 1 22 16.92z"/>',
  ],
  Mail: [
    '<rect width="20" height="16" x="2" y="4" rx="2"/>',
    '<path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>',
  ],
  MapPin: [
    '<path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z"/>',
    '<circle cx="12" cy="10" r="3"/>',
  ],
  Clock: ['<circle cx="12" cy="12" r="10"/>', '<polyline points="12 6 12 12 16 14"/>'],
  Grid2X2: [
    '<rect width="7" height="7" x="3" y="3" rx="1"/>',
    '<rect width="7" height="7" x="14" y="3" rx="1"/>',
    '<rect width="7" height="7" x="14" y="14" rx="1"/>',
    '<rect width="7" height="7" x="3" y="14" rx="1"/>',
  ],
  List: [
    '<line x1="8" x2="21" y1="6" y2="6"/>',
    '<line x1="8" x2="21" y1="12" y2="12"/>',
    '<line x1="8" x2="21" y1="18" y2="18"/>',
    '<line x1="3" x2="3.01" y1="6" y2="6"/>',
    '<line x1="3" x2="3.01" y1="12" y2="12"/>',
    '<line x1="3" x2="3.01" y1="18" y2="18"/>',
  ],
  ArrowUpDown: [
    '<path d="m21 16-4 4-4-4"/>',
    '<path d="M17 20V4"/>',
    '<path d="m3 8 4-4 4 4"/>',
    '<path d="M7 4v16"/>',
  ],
  ArrowLeft: ['<path d="m12 19-7-7 7-7"/>', '<path d="M19 12H5"/>'],
  ArrowRight: ['<path d="M5 12h14"/>', '<path d="m12 5 7 7-7 7"/>'],
  Check: ['<path d="M20 6 9 17l-5-5"/>'],
  Grid3X3: [
    '<rect width="18" height="18" x="3" y="3" rx="2"/>',
    '<path d="M3 9h18"/>',
    '<path d="M3 15h18"/>',
    '<path d="M9 3v18"/>',
    '<path d="M15 3v18"/>',
  ],
  Package: [
    '<path d="m7.5 4.27 9 5.15"/>',
    '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/>',
    '<path d="m3.3 7 8.7 5 8.7-5"/>',
    '<path d="M12 22V12"/>',
  ],
  Ban: ['<circle cx="12" cy="12" r="10"/>', '<path d="m4.9 4.9 14.2 14.2"/>'],
  Eye: [
    '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>',
    '<circle cx="12" cy="12" r="3"/>',
  ],
  Tag: [
    '<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/>',
    '<circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',
  ],
};

export function iconoLucide(nombre, { clase = '', label = '' } = {}) {
  const contenido = ICONOS[nombre] ?? ICONOS.ShoppingBag;
  const aria = label ? `role="img" aria-label="${label}"` : 'aria-hidden="true"';
  const claseAttr = clase ? ` class="${clase}"` : '';

  return `<svg${claseAttr} ${aria} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${contenido.join('')}</svg>`;
}
